import { Sidebar } from '@consta/uikit/Sidebar'
import { Delimiter, For } from '@library/components'
import {
  constructBrowserTabUrl,
  getDisplayName,
  getIconByType,
  VISIBLE_BROWSER_TABS,
} from '@library/model'
import type { ProjectId } from 'common/types'
import type { FC } from 'react'

import { NavigationItem } from './NavigationItem'
import css from './NavigationSidebar.css'
import { SidebarHeader } from './SidebarHeader'

type NavigationSidebarProps = {
  projectId: ProjectId
  projectName: string
  isOpen: boolean
  handleClose: VoidFunction
}

export const NavigationSidebar: FC<NavigationSidebarProps> = ({
  handleClose,
  isOpen,
  projectName,
  projectId,
}) => {
  return (
    <Sidebar
      className={css.sidebar}
      isOpen={isOpen}
      hasOverlay={true}
      position="left"
      onEsc={handleClose}
      onClickOutside={handleClose}>
      <Sidebar.Content>
        <SidebarHeader projectName={projectName} handleClose={handleClose} />
        <Delimiter className={css.divider} position="horizontal" />
        <div className={css.buttons}>
          <For each={VISIBLE_BROWSER_TABS}>
            {tabType => (
              <NavigationItem
                key={tabType}
                label={getDisplayName(tabType)}
                icon={getIconByType(tabType)}
                href={constructBrowserTabUrl(tabType, projectId)}
                onSelect={handleClose}
              />
            )}
          </For>
        </div>
      </Sidebar.Content>
    </Sidebar>
  )
}
